import { store } from '@/common/root';
import jsonParseSafe from '@/common/utils/jsonParseSafe';
import usePermissionsStore from '@/common/store/pinia/permissions';
import useAuthStore from '@/common/store/pinia/auth';
import checkTopLevelStorageAccess from '@/common/utils/checkTopLevelStorageAccess';
import { UserAccount } from '@schema';

async function init(pinia) {
  const authStore = useAuthStore();

  await checkTopLevelStorageAccess(authStore.setStorageAccessState);

  /* Fetch and Set the current user in case there's one */
  const userCredentials = localStorage.getItem('user');
  const scopedToken = localStorage.getItem('scopedToken') || '';
  const domain = localStorage.getItem('domain') || '';
  const currentProject = localStorage.getItem('currentProject') || '';

  const permissionsStore = usePermissionsStore(pinia);

  if (userCredentials) {
    authStore.setCurrentUser(jsonParseSafe(userCredentials) as UserAccount || {});
  }

  if (userCredentials || scopedToken) {
    authStore.setProject(currentProject);
    authStore.setToken(scopedToken);
    authStore.setDomain(domain);

    await authStore.checkAccessDisabled();
    if (currentProject) {
      // check if the user still able to perform actions in the project
      await authStore.signInProject(currentProject);
    } else {
      await permissionsStore.fetchAuthMeta();
      await store.dispatch('socket/CONNECT');
    }
  }
}

export default init;
